import React, { useId } from 'react';
import type { ColorValue, ViewProps } from 'react-native';
import { View } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

interface GradientProps {
  from: ColorValue;
  to: ColorValue;
  fromOpacity?: number;
  toOpacity?: number;
  style: ViewProps['style'];
  height?: number;
  borderRadius?: number;
  invert?: boolean;
}

export function Gradient({
  from,
  fromOpacity = 1,
  to,
  toOpacity = 1,
  style,
  borderRadius = 0,
  invert,
  height,
}: GradientProps) {
  const gradientId = `gradient-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;

  return (
    <View pointerEvents="none" style={style}>
      <Svg height={height ?? '100%'} width="100%">
        <Defs>
          <LinearGradient id={gradientId} x1="0%" x2="0%" y1="0%" y2="100%">
            <Stop offset={invert ? '1' : '0'} stopColor={from} stopOpacity={fromOpacity} />
            <Stop offset={invert ? '0' : '1'} stopColor={to} stopOpacity={toOpacity} />
          </LinearGradient>
        </Defs>
        <Rect fill={`url(#${gradientId})`} height={height ?? '100%'} rx={borderRadius} width="100%" />
      </Svg>
    </View>
  );
}
